
// export const logout = ( state ) => {
// }

export const setGeneralInventory = (state, generalInventory) => {
    state.generalInventory = generalInventory;
}

export const setGeneralInventoryIsLoading = (state, isLoading) => {
    state.generalInventoryisLoading = isLoading
}

export const setGeneralInventoryPaginated = (state, generalInventoryPaginated) => {
    state.generalInventoryPaginated = generalInventoryPaginated;
}